import { render, staticRenderFns } from "./SuccessTraining.vue?vue&type=template&id=548dfa00&"
import script from "./SuccessTraining.vue?vue&type=script&lang=js&"
export * from "./SuccessTraining.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports